import {BaseEditItemStore} from "@leap4/frontend";
import {IGroup} from "../../interfaces/IGroup";

export class EditGroupStore extends BaseEditItemStore<IGroup>{
    entityName: string = "Group";
}